import { createSlice } from "@reduxjs/toolkit";

const refNoSlice = createSlice({
  name: "refNo",
  initialState: {
    value: "", // will store your refNo here
  },
  reducers: {
    setRefNo: (state, action) => {
      state.value = action.payload;
    },
    clearRefNo: (state) => {
      state.value = "";
    },
  },
});

export const { setRefNo, clearRefNo } = refNoSlice.actions;
export default refNoSlice.reducer;
